// extracted by mini-css-extract-plugin
module.exports = {"summary":"_2xtwcs_bitEgiYZisfwQrc","text":"_1iPHcJqSCS8ZngH2qfSw0I","expanded":"MXRxECCkcUD5F5jWa-rjp","viewMore":"XV6VmMjaH2JiCsQHAxPiS"};